import { Placeholder } from "semantic-ui-react";
import React from "react";

export function PlaceholderHeader() {
  return (
    <Placeholder>
      <Placeholder.Header>
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Header>
    </Placeholder>
  );
}
